import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const Navbar = ({ dark = false, mobile = false, showSocials = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const textColor = dark ? 'text-white' : 'text-gray-800';
  const bgColor = dark ? 'bg-black' : 'bg-white';
  const dropdownBg = dark ? 'bg-gray-800' : 'bg-white';
  
  let navLinks = [
    { path: '/', label: '→Main' },
    { path: '/projects', label: '→Projects' },
    { path: '/cv', label: '→CV' },
    { path: '/research', label: '→Research' },
    { path: '/contact', label: '→Contact info' },
  ];
  
  if (showSocials) {
    navLinks.push({ path: '/socials', label: '→Socials' });
  }
  
  // Mobile Menu
  if (mobile) {
    return (
      <div className="px-6 py-8">
        <div className="relative flex justify-center">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`flex items-center space-x-2 text-2xl font-light ${textColor}`}
          >
            <span>Menu</span>
            <ChevronDown className={`w-6 h-6 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} />
          </button>
          
          {isMenuOpen && (
            <div className={`absolute top-full mt-2 ${dropdownBg} shadow-lg rounded-lg p-4 z-10 min-w-[200px]`}>
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link 
                      to={link.path}
                      className={`block text-lg font-light ${textColor} hover:underline`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }
  
  // Desktop Navbar
  return (
    <nav className={`${bgColor} shadow-sm px-8 py-6`}>
      <div className="max-w-7xl mx-auto">
        <ul className="flex flex-wrap justify-center space-x-8 text-lg font-light">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link to={link.path} className={`${textColor} hover:underline transition-all`}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;